import { render } from "./user-administration-card.vue?vue&type=template&id=edca10e6"
import script from "./user-administration-card.vue?vue&type=script&lang=js"
export * from "./user-administration-card.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__